import { fetchAllScheduledMessages } from 'components/domain/automation/scheduledMessages/scheduledMessagesQuery';
import FilterFormContextSearchField from 'components/filters/FilterFormContextSearchField';
import { SearchOption } from 'components/filters/FilterFormContextSearchField.styles';
import useFilterFormContext from 'components/filters/useFilterFormContext';
import useAppMutation from 'hooks/useAppMutation';

const ScheduledMessageSearchField = () => {
  const { searchFieldRef } = useFilterFormContext();
  const { mutateAsync: searchScheduledMessages } = useAppMutation({
    mutationFn: fetchAllScheduledMessages,
  });

  const searchHandler = async (query: string) => {
    const data = await searchScheduledMessages({ messageName: query });
    return data.scheduledMessages;
  };

  return (
    <FilterFormContextSearchField
      containerClassName="search-field"
      labelKey={(option) => `${option.messageName ?? ''}`}
      name="scheduledMessageSearch"
      instanceRef={searchFieldRef}
      renderMenuItemChildren={(option) => (
        <SearchOption data-testid={`found-scheduled-message-${option.uid}`}>
          {option.messageName}
        </SearchOption>
      )}
      searchHandler={searchHandler}
    />
  );
};

export default ScheduledMessageSearchField;
